export const INTERNAL_PAGE_TYPES = {
	CITY_LANDING_PAGE: 'cityLandingPage',
	AMENITY_LANDING_PAGE: 'amenityLandingPage',
	VEHICLE_LANDING_PAGE: 'vehicleLandingPage',
};
